import { TFunction } from 'i18next'
import { OnboardingStep } from 'types/onboardingTypes'
import { content, info, title, wordings } from './Consts'

export function getHeight(t: TFunction): OnboardingStep {
  const height = 'height.'

  return {
    id: 'height',
    type: 'height',
    wordings: {
      title: t(`${height}${wordings}${title}`),
      placeholder: '',
      info: {
        title: t(`${height}${wordings}${info}.${title}`),
        content: t(`${height}${wordings}${info}.${content}`)
      }
    }
  }
}
